// Add new runtime config to .env with dev defaults
// docker will create env-config.js that will load runtime config into window.env
// See https://github.com/kunokdev/cra-runtime-environment-variables
//
// Note: make sure line endings in env.sh and .env are LF (linux) style 
declare global {
    interface Window {
        env: any
    }
}
// change with your own variables
type EnvType = {
    REACT_APP_CLIENT_ID: string,
    REACT_APP_BILLING_SCOPE: string,
}
export const env: EnvType = { ...process.env, ...window.env }